// extracted by mini-css-extract-plugin
export default {"paiTopo":"ListarUser_paiTopo__blB1Z","pai":"ListarUser_pai__uyNd1"};